import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/app/rootReducer";
import { closeFileManagerDialog } from "@/app/globalSlices/fileManagerDialogSlice";
import FilePickerDialog from "@/modules/hub/features/FileManagement/components/FilePickerDialog/FilePickerDialog";

/**
 * FileManagerGlobalDialog
 *
 * A global dialog component that renders the FilePickerDialog in manager mode
 * when triggered from the navigation. This allows users to manage files without
 * leaving their current page context.
 */
export function FileManagerGlobalDialog() {
  const dispatch = useDispatch();
  const isOpen = useSelector(
    (state: RootState) => state.fileManagerDialog.isOpen,
  );

  const handleClose = () => {
    dispatch(closeFileManagerDialog());
  };

  return (
    <FilePickerDialog
      isOpen={isOpen}
      mode="manager"
      multiSelect={true} // Allow multi-select for bulk operations
      onClose={handleClose}
      onSelect={() => {}} // No-op in manager mode
    />
  );
}

export default FileManagerGlobalDialog;
